import { createSelector } from '@reduxjs/toolkit';
import { getRoomTypesWithoutOffers as getAllRoomTypes } from 'store/property/propertySelectors';

export const getTotalRoomTypeCount = createSelector(getAllRoomTypes, (allRoomTypes) => allRoomTypes?.length || 0);
